import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Default } from "../client/clientSlice";
import { RootState } from "../../app/store";

interface SystemState {
    selectSetup: Default | null;
}

const initialState: SystemState  = {
    selectSetup: null,
};

const systemSlice = createSlice({
    name: 'system',
    initialState,
    reducers: {
        setSelectedSetup: (state, action: PayloadAction<Default | null>) => {
            state.selectSetup = action.payload;
        },
        clearSelectedSetup: (state) => {
            state.selectSetup = null;
        },
    }
});

export const { 
    setSelectedSetup,
    clearSelectedSetup
} = systemSlice.actions;

export const selectSetup = (state: RootState) => state.system.selectSetup;
export const selectSetupName = (state: RootState) => state.system.selectSetup?.name;
export const selectSetupId = (state: RootState) => state.system.selectSetup?.id;

export default systemSlice.reducer;